module.exports = "<div class=\"dialog-container\">\n  <h1 mat-dialog-title>Oh no!</h1>\n  <div mat-dialog-content>\n    <p>Are you sure you want to delete your account?</p>\n  </div>\n  <div mat-dialog-actions>\n    <button class=\"button-outline-warn\" [mat-dialog-close]=\"true\">Yea, I'm out.</button>\n    <button class=\"button-outline\" [mat-dialog-close]=\"false\" cdkFocusInitial>Nah, I'm good.</button>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/profile/confirm-delete-dialog.html
// module id = ../../../../../src/app/profile/confirm-delete-dialog.html
// module chunks = main